var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarBookmarkActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 37,
    viewBox: "0 0 39 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 960285"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 21",
    d: "M0 0H39V37L0 0Z",
    fill: "#CCE5EF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Primary",
    d: "M26.3094 3L28.3367 6.84375L32.6187 7.58438L29.5883 10.6992L30.207 15L26.3094 13.0828L22.4094 15L23.0281 10.6992L20 7.58438L24.2797 6.84375L26.3094 3Z",
    fill: "#BA5D00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarBookmarkActive);
export default __webpack_public_path__ + "static/media/star-bookmark-active.9a7cf2d2f003d2990346637c37229b7f.svg";
export { ForwardRef as ReactComponent };